import { useEffect, useState } from "react";
import { Alert, Snackbar } from "@mui/material";
import { sessionManager } from "../context/sessionManager";

const SessionWarning = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const checkSessionTimeout = () => {
      const remainingTime = sessionManager.getRemainingTime();
      const minutes = Math.floor(remainingTime / (1000 * 60));
      
      if (minutes <= 5 && minutes > 0) {
        setMessage(`Your session will expire in ${minutes} minute${minutes !== 1 ? 's' : ''}. Please save your work.`);
        setOpen(true);
      } else if (minutes <= 0) {
        setMessage("Session expired. Redirecting to login...");
        setOpen(true);
      } else {
        setOpen(false);
      }
    };

    const interval = setInterval(checkSessionTimeout, 60000); // Check every minute
    checkSessionTimeout(); // Initial check

    return () => clearInterval(interval);
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert 
        onClose={handleClose} 
        severity="warning" 
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SessionWarning;